import type { IconProps } from "@expo/vector-icons/build/createIconSet";
import type { ComponentProps } from "react";
import * as ContextMenu from "zeego/context-menu";
import { QendoIcon, type QendoIconSet } from "~/components/QendoIcon";

type ItemIconProps = {
    icon: QendoIconSet;
    iconProps?: Omit<IconProps<QendoIconSet>, "name" | "size">;
} & ComponentProps<typeof ContextMenu.ItemIcon>;

export const MenuItemIcon = ContextMenu.create(
    ({ icon, children, iconProps, ...itemIconProps }: ItemIconProps) => (
        <ContextMenu.ItemIcon {...itemIconProps}>
            {children ?? <QendoIcon {...iconProps} name={icon} size={20} />}
        </ContextMenu.ItemIcon>
    ),
    "ItemIcon",
);
